import e from"../helpers/isAbsoluteURL.js";import r from"../helpers/combineURLs.js";function o(o,s,t){let i=!e(s);return o&&(i||0==t)?r(o,s):s}export{o as default};
//# sourceMappingURL=buildFullPath.js.map
